import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface Gametype {
  order: number;
  pageTitle: string;
  headText: string;
  headParagraph: string;
}

export interface Partner {
  id: string;
  name: string;
  logo: string;
  bonusText: string;
  partnerUrl: string;
  isMobile: boolean;
  order: number;
}

export interface ApiResponse {
  gametypes: Gametype[];
  partners: Partner[];
}

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private readonly API_URL = environment.apiUrl || 'https://api.example.com/data';
  private readonly MOCK_DATA_URL = '/assets/mockDev.json';
  private dataCache$: Observable<ApiResponse> | null = null;

  constructor(private http: HttpClient) {}

  getData(): Observable<ApiResponse> {
    // Cache the result to prevent multiple HTTP calls
    if (!this.dataCache$) {
      this.dataCache$ = this.http.get<ApiResponse>(this.MOCK_DATA_URL).pipe(
        catchError((err) => {
          // Silently fail - don't spam console with errors
          // Fallback to empty data if mock data also fails
          return of({ gametypes: [], partners: [] });
        }),
        shareReplay(1) // Cache and replay the last value
      );
    }
    return this.dataCache$;
  }
}

